const { findByAddress } = require('@hints/utils/data');
const Interpretor = require('./interpretor');

module.exports = new Interpretor([
    {
        id: 'no-insomnia',
        conditions: [{ id: 'score', min: 0, max: 7, value: e => findByAddress(e, 'evalSleep.isiAnswerScore') }],
    },
    {
        id: 'subclinical-insomnia',
        conditions: [{ id: 'score', min: 8, max: 14, value: e => findByAddress(e, 'evalSleep.isiAnswerScore') }],
    },
    {
        id: 'moderate-insomnia',
        conditions: [{ id: 'score', min: 15, max: 21, value: e => findByAddress(e, 'evalSleep.isiAnswerScore') }],
    },
    {
        id: 'severe-insomnia',
        conditions: [{ id: 'score', min: 22, max: 28, value: e => findByAddress(e, 'evalSleep.isiAnswerScore') }],
    }
]);